(() => {
  const root = document.querySelector('.xd-pdp-test');
  const card = root?.querySelector('[data-xd-purchase-card]');
  const form = document.getElementById('xd-functional-baskets-product-form');
  if (!root || !card || root.dataset.xdPurchaseController) return;
  root.dataset.xdPurchaseController = 'ready';

  const parseJson = (value, fallback) => {
    try { return JSON.parse(value || ''); } catch (_) { return fallback; }
  };
  const variants = parseJson(card.dataset.xdVariants, []);
  const optionGroups = [...card.querySelectorAll('[data-xd-option-index]')];
  const nativeVariant = form?.querySelector('[data-xd-native-variant-id], input[name="id"]');
  const sku = card.querySelector('[data-xd-variant-sku]');
  const price = card.querySelector('[data-xd-variant-price]');
  const stock = card.querySelector('[data-xd-variant-stock]');
  const nativeAdd = form?.querySelector('[data-xd-native-add]');
  const mockAdd = card.querySelector('.xd-button-cart');
  const mockQuantity = card.querySelector('[data-xd-quantity]');
  const nativeQuantity = form?.querySelector('[data-xd-native-quantity]');

  const selectedOptions = () => optionGroups.map(group => group.querySelector('[data-xd-option-value][aria-pressed="true"]')?.dataset.xdOptionValue || '');
  const matchingVariant = () => variants.find(variant => variant.options?.every((value, index) => value === selectedOptions()[index]));
  const money = cents => window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents) : `$${(Number(cents || 0) / 100).toFixed(2)}`;
  const syncVariant = () => {
    const variant = matchingVariant();
    if (!variant) return;
    if (nativeVariant) nativeVariant.value = variant.id;
    if (sku) sku.textContent = `SKU: ${variant.sku || ''}`;
    if (price) price.textContent = money(variant.price);
    if (stock) stock.textContent = variant.available ? 'Available to order.' : 'Backordered and will ship as soon as it is back in stock.';
    if (mockAdd) mockAdd.disabled = !variant.available;
    card.dispatchEvent(new CustomEvent('xd:variant-change', { bubbles: true, detail: { variant } }));
  };

  optionGroups.forEach(group => {
    group.querySelectorAll('[data-xd-option-value]').forEach(button => {
      button.addEventListener('click', () => {
        group.querySelectorAll('[data-xd-option-value]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
        syncVariant();
      });
    });
  });

  const syncQuantity = () => {
    if (nativeQuantity) nativeQuantity.value = Math.max(1, Number(mockQuantity?.value || 1));
  };
  card.querySelectorAll('[data-xd-quantity-plus],[data-xd-quantity-minus]').forEach(button => button.addEventListener('click', () => requestAnimationFrame(syncQuantity)));
  mockQuantity?.addEventListener('input', syncQuantity);
  mockQuantity?.addEventListener('change', syncQuantity);
  mockAdd?.addEventListener('click', () => { syncQuantity(); nativeAdd?.click(); });
  syncQuantity();
  syncVariant();

  const galleryImages = parseJson(card.dataset.xdGalleryImages, []);
  const stage = root.querySelector('[data-xd-stage-image]');
  const thumbsContainer = root.querySelector('[data-xd-thumbs]');
  const counter = root.querySelector('[data-xd-image-counter]');
  const counterNumber = root.querySelector('[data-xd-image-number]');
  const counterTotal = root.querySelector('[data-xd-image-total]');
  const previous = root.querySelector('[data-xd-gallery-previous]');
  const next = root.querySelector('[data-xd-gallery-next]');
  if (!stage) return;
  const imageUrl = media => media.preview_image?.src || media.src || '';
  const setNavVisibility = hidden => { previous?.toggleAttribute('hidden', hidden); next?.toggleAttribute('hidden', hidden); };
  if (!galleryImages.length) {
    thumbsContainer?.setAttribute('hidden', ''); counter?.setAttribute('hidden', ''); setNavVisibility(true); return;
  }
  let index = 0;
  const thumbs = galleryImages.map((media, imageIndex) => {
    const thumb = document.createElement('button');
    thumb.className = 'xd-thumb'; thumb.type = 'button'; thumb.dataset.xdThumbnail = String(imageIndex);
    // Variant picker selects its Shopify featured_media by this stable media ID.
    if (media && media.id != null) thumb.dataset.xdMediaId = String(media.id);
    thumb.setAttribute('aria-label', `${media.media_type === 'image' ? 'View product image' : 'View product video'} ${imageIndex + 1}${media.alt ? ': ' + media.alt : ''}`);
    if (media.media_type !== 'image') { const badge = document.createElement('span'); badge.className = 'xd-video-badge'; badge.textContent = '▶'; badge.setAttribute('aria-hidden', 'true'); thumb.append(badge); }
    const src = imageUrl(media); if (src) thumb.style.backgroundImage = `url("${src}")`;
    thumb.addEventListener('click', () => { index = imageIndex; paint(); }); thumbsContainer?.appendChild(thumb); return thumb;
  });
  const paint = () => {
    const media = galleryImages[index]; const src = imageUrl(media);
    stage.querySelectorAll('video').forEach(video => video.pause());
    stage.replaceChildren();
    const isVideo = media.media_type === 'external_video' || media.media_type === 'video';
    if (src) {
      const image = document.createElement('img');
      image.src = isVideo ? imageUrl(galleryImages[0]) : src;
      image.alt = isVideo ? '' : media.alt || card.dataset.xdProductTitle || '';
      if (isVideo) image.style.visibility = 'hidden';
      stage.append(image);
    }
    if (isVideo) {
      const play = document.createElement('button'); play.type = 'button';
      play.className = 'xd-video-layer xd-video-play'; play.dataset.xdVideoPlay = '';
      play.setAttribute('aria-label', `Play ${media.alt || card.dataset.xdProductTitle || 'product'} video`);
      const poster = document.createElement('img'); poster.src = src; poster.alt = '';
      const badge = document.createElement('span'); badge.className = 'xd-video-badge'; badge.textContent = '▶'; badge.setAttribute('aria-hidden','true');
      play.append(poster,badge); stage.append(play);
      play.addEventListener('click', () => {
        let player;
        if (media.media_type === 'external_video' && media.host === 'youtube' && /^[\w-]+$/.test(media.external_id || '')) {
          player = document.createElement('iframe');
          player.src = `https://www.youtube.com/embed/${encodeURIComponent(media.external_id)}?autoplay=1&playsinline=1&rel=0`;
          player.title = media.alt || 'Product video'; player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; player.allowFullscreen = true;
          player.referrerPolicy = 'strict-origin-when-cross-origin';
        } else if (media.media_type === 'video') {
          player = document.createElement('video'); player.controls = true; player.playsInline = true; player.preload = 'metadata'; player.poster = src;
          (media.sources || []).forEach(source => { const child = document.createElement('source'); child.src = source.url; child.type = source.mime_type; player.append(child); });
        } else { play.setAttribute('aria-label', 'This video provider is not supported'); return; }
        player.className = 'xd-video-layer'; player.tabIndex = 0; play.replaceWith(player); player.focus();
        if (player.tagName === 'VIDEO') player.play().catch(() => {});
      }, { once: true });
    }
    counterNumber.textContent = String(index + 1); counterTotal.textContent = String(galleryImages.length);
    thumbs.forEach((thumb, thumbIndex) => { thumb.classList.toggle('is-active', thumbIndex === index); thumb.setAttribute('aria-pressed', String(thumbIndex === index)); });
  };
  // Keep the real Shopify variant's assigned featured media synchronized with the gallery.
  // Manual gallery navigation remains available; this only runs on a variant selection.
  const syncGalleryToVariant = (variant) => {
    const featuredMediaId = variant?.featured_media?.id;
    if (featuredMediaId == null) return;
    const matchingIndex = galleryImages.findIndex((media) => String(media?.id) === String(featuredMediaId));
    if (matchingIndex < 0 || matchingIndex === index) return;
    index = matchingIndex;
    paint();
  };
  card.addEventListener('xd:variant-change', (event) => syncGalleryToVariant(event.detail?.variant));
  syncGalleryToVariant(matchingVariant());

  setNavVisibility(galleryImages.length < 2);
  previous?.addEventListener('click', () => { index = (index - 1 + galleryImages.length) % galleryImages.length; paint(); });
  next?.addEventListener('click', () => { index = (index + 1) % galleryImages.length; paint(); });
  paint();
})();
